import axios from "axios";

// =========================
// 🔹 Base API URLs
// =========================
const BASE_URL = "/api";
const AUTH_URL = `${BASE_URL}/auth`;
const GUARD_URL = `${BASE_URL}/guard`;
const USER_URL = `${BASE_URL}/user`;

// =========================
// 🔹 Public Auth APIs
// =========================
export const loginUser = (phoneNumber, password) => {
  return axios.post(`${AUTH_URL}/login`, { phoneNumber, password });
};

export const registerUser = (userData, role) => {
  let endpoint = "/register/user";
  if (role === "guard") endpoint = "/register/guard";
  if (role === "admin") endpoint = "/register/admin";

  return axios.post(`${AUTH_URL}${endpoint}`, userData);
};

// =========================
// 🔹 Axios instance with JWT interceptor
// =========================
export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
});

axiosPrivate.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// =========================
// 🔹 Guard APIs
// =========================
export const sendVisitorRequest = (requestData) => {
  return axiosPrivate.post(`${GUARD_URL}/request`, requestData);
};

// =========================
// 🔹 User/Owner APIs
// =========================
export const respondToVisitor = (id, status) => {
  return axiosPrivate.post(`${USER_URL}/respond/${id}?status=${status}`);
};

export const getUserProfile = () => {
  return axiosPrivate.get(`${USER_URL}/profile`);
};

export const updateUserProfile = (userDto) => {
  return axiosPrivate.put(`${USER_URL}/profile`, userDto);
};

export const changeUserPassword = (data) => {
  return axiosPrivate.post(`${USER_URL}/change-password`, data);
};

// =========================
// 🔹 Default Export (for backward compatibility)
// =========================
export default {
  loginUser,
  registerUser,
  sendVisitorRequest,
  respondToVisitor,
  getUserProfile,
  updateUserProfile,
  changeUserPassword,
  axiosPrivate,
};
